import React, { useEffect } from 'react';
import CssLanding from './CssLanding';

const PetLanding: React.FC = () => {
  // Set pet mode in localStorage when this component mounts
  useEffect(() => {
    localStorage.setItem('selectedMode', 'pet');
    console.log('🐾 Pet mode activated via /pet route');
  }, []);

  // Render the regular landing page (it will read pet mode from localStorage)
  return <CssLanding />;
};

export default PetLanding;
